import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { GenerateTicketModalComponent } from '../../ticketing/generate-ticket-modal/generate-ticket-modal.component';
import { ApiService } from 'src/app/services/api/api.service';
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { ConfirmActionComponent } from 'src/app/shared/components/confirm-action/confirm-action.component';
import { AuthService } from 'src/app/services/auth/auth.service';
import { UtilitiesService } from 'src/app/services/utilities/utilities.service';

@Component({
  selector: 'app-workflow-create',
  standalone: false,
  templateUrl: './workflow-create.component.html',
  styleUrl: './workflow-create.component.scss',
})
export class WorkflowCreateComponent implements OnInit {
  form: FormGroup;
  approvalForm: FormGroup;
  isDarkMode!: boolean;
  data: any = null;

  isLoadingPrivileges: boolean = true;

  isSubmitting: boolean = false;
  isSubmitAttempted: boolean = false;
  isLoading: boolean;

  showErrorMessages: boolean = false;

  approvalList: any[] = [];

  lgaList: any;
  zoneList: any;

  workflos: any[] = [
    'ASSESSMENT',
    'LGA_IDENTIFICATION',
    'STREET_NAMING',
    'MARRIAGE_REGISTRATION',
    'DEATH_REGISTRATION',
  ];
  steges: any[] = [
    { id: 1, formattedName: 'Stage 1' },
    { id: 2, formattedName: 'Stage 2' },
    { id: 3, formattedName: 'Stage 3' },
    { id: 4, formattedName: 'Stage 4' },
    { id: 5, formattedName: 'Stage 5' },
    { id: 6, formattedName: 'Stage 6' },
  ];
  actions: any[] = [
    { id: 'NEXT', formattedName: 'Next Step' },
    { id: 'FINAL', formattedName: 'Final Step' },
  ];
  admins: any[] = [];
  lgas: any[] = [];

  rememberMe: boolean;
  isDisabled: boolean = false;

  constructor(
    private dialog: MatDialog,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<GenerateTicketModalComponent>,
    private apiService: ApiService,
    private authService: AuthService,
    private utilitiesService: UtilitiesService
  ) {}

  ngOnInit(): void {
    const userDt = localStorage.getItem('USER_DATA');
    if (userDt) {
      this.data = JSON.parse(userDt);
    }

    this.initForm();
    this.initApprovalForm();
    this.getLgas();

    this.loadLgaList();
    this.subscribeToLgaChanges();
    this.subscribeToZoneChanges();
  }

  get lgaControl() {
    return this.form.get('lga') as FormControl;
  }

  get zoneControl() {
    return this.form.get('zone') as FormControl;
  }

  loadLgaList() {
    this.utilitiesService.getLocalGovernmentList().subscribe(
      (response) => {
        this.lgaList = response;
      },
      (error) => {
        this.openErrorModal('Error Fetching Local Government');
      }
    );
  }

  subscribeToLgaChanges() {
    this.lgaControl.valueChanges.subscribe((lga) => {
      this.zoneList = null;
      this.zoneControl.reset();
      this.getZonesFromLga(lga);
      // this.getAdminUers(lga);
    });
  }

  subscribeToZoneChanges() {
    this.zoneControl.valueChanges.subscribe((zone) => {
      this.getAdminUers(this.lgaControl.value, zone);
    });
  }

  getZonesFromLga(lga) {
    this.utilitiesService.getZonesFromLga(lga).subscribe((res: any) => {
      this.zoneList = res;
    });
  }

  getAdminNate(id: number) {
    return this.admins.find((admin) => admin.id === id);
  }

  getStages(id: number) {
    return this.steges.find((stage) => stage.id === id);
  }
  getAction(id: number) {
    return this.actions.find((action) => action.id === id);
  }

  initApprovalForm(): void {
    this.approvalForm = this.fb.group({
      approverId: [null, Validators.required],
      stageNumber: [null, Validators.required],
      onApproved: [null, Validators.required],
    });
  }

  addToList(): void {
    if (this.approvalForm.valid) {
      const newItem = this.approvalForm.value;

      // Check if an item with the same stageNumber and onApproved already exists
      const exists = this.approvalList.some(
        (item) =>
          item.stageNumber === newItem.stageNumber &&
          item.onApproved === newItem.onApproved
      );

      if (!exists) {
        this.approvalList.push(newItem);
        this.approvalForm.reset();
        this.showErrorMessages = false;
      } else {
        this.openErrorModal('Workflow stage already added');
      }
    } else {
      this.openErrorModal('Invalid workflow stage');
    }
  }

  initForm(): void {
    this.form = this.fb.group({
      workflowName: [null, [Validators.required]],
      description: [null],
      lga: [null, Validators.required],
      zone: [null, Validators.required],
      workflowStages: [null],
    });
  }

  getAdminUers(lgaId: number, zoneId: number) {
    this.isLoading = true;
    this.apiService
      .get(`/auth/lga/admins?lgaId=${lgaId}`)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((response: any) => {
        this.admins = response.data.map((admin) => ({
          ...admin,
          formattedName: this.toTitleCase(admin.displayName.replace(/_/g, ' ')),
        }));
      });
  }

  getLgas() {
    this.isLoading = true;
    this.apiService
      .get('/utility/all/lga')
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((response: any) => {
        this.lgas = response.map((lga) => ({
          ...lga,
          formattedName: this.toTitleCase(lga.name.replace(/_/g, ' ')),
        }));
        //init defauld
        if (!this.data?.permissions.includes('GENERAL_PERMISSION')) {
          this.lgas = this.lgas
            .filter((lga) => lga?.id == this.data?.lgaId)
            .map((lga) => ({
              ...lga,
              formattedName: this.toTitleCase(lga.name.replace(/_/g, ' ')),
            }));

          this.form.patchValue({
            lga: this.lgas.length ? this.lgas[0].id : null,
          });

          this.form.get('lga')?.disable();
          this.isDisabled = true;
        }
      });
  }

  toTitleCase(str: string): string {
    return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  }

  closeModal(): void {
    if (!this.isSubmitting) {
      this.dialogRef.close();
    }
  }

  openSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      location.reload();
    });
  }

  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {});
  }

  openConfirmModal() {
    let dialogRef = this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: 'Create Workflow?',
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {
          this.createWorkflow();
        },
        onCancel: () => {
          // dialogRef.close()
        },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });
  }

  removeFromList(index: number): void {
    this.approvalList.splice(index, 1);
  }

  createWorkflow(): void {
    this.form.patchValue({ workflowStages: this.approvalList });

    this.isSubmitting = true;
    this.apiService
      .post('/workflow/create', this.form.getRawValue())
      .pipe(
        finalize(() => {
          this.isSubmitting = false;
        })
      )
      .subscribe(
        (response: any) => {
          if (response !== 'ALREADY_REPORTED') {
            this.openSuccessModal('Workflow Created');
          } else {
            this.openErrorModal('Workflow already exist');
          }

          this.dialogRef.close();
        },
        (error) => {
          this.openErrorModal(error?.message);
        }
      );

    this.isSubmitAttempted = true;
  }
}
